<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Can't do this here</template>

    <Sheet.Body>
      <p class="text-[14px] leading-[22px] text-gray-800">
        Please go to your {{ store }} settings in order to resubscribe to your
        {{ planName }} plan.
      </p>
    </Sheet.Body>

    <div
      class="flex shrink-0 flex-col px-4 pt-2 pb-[calc(env(safe-area-inset-bottom)+16px)]"
    >
      <Button variant="primary" size="lg" @click="handleGoClick">
        Go to {{ store }} settings
      </Button>
    </div>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Button, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import { useResubscribeIAP } from './useResubscribeIAP'

const { close } = useSheet()
const { store, planName, handleGo } = useResubscribeIAP()

const handleGoClick = () => {
  close()
  handleGo()
}
</script>
